/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { IssueImage, IssueImageFromJSON, IssueImageFromJSONTyped, IssueImageToJSON } from "./IssueImage";

/**
 *
 * @export
 * @interface IssueImageControllerResponse
 */
export interface IssueImageControllerResponse {
  /**
   *
   * @type {IssueImage}
   * @memberof IssueImageControllerResponse
   */
  data?: IssueImage;
  /**
   *
   * @type {ErrorResponse}
   * @memberof IssueImageControllerResponse
   */
  error?: ErrorResponse;
}

export function IssueImageControllerResponseFromJSON(json: any): IssueImageControllerResponse {
  return IssueImageControllerResponseFromJSONTyped(json, false);
}

export function IssueImageControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IssueImageControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : IssueImageFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function IssueImageControllerResponseToJSON(value?: IssueImageControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: IssueImageToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
